import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Header from "go-app/components/Header";

interface Props {
	redirect_uri: string | null;
}

const NoOrganizationLoanAccess = ({ redirect_uri }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<>
			<Header title={t("modules.loan.header.title")} />
			<div className={"content-preview"}>
				<Alert variant={"danger"}>
					{t("modules.partner.field.no_location_access.title")}&nbsp;
					{redirect_uri && <a href={redirect_uri}>{t("common.action.back", { ns: "lib" })}</a>}
				</Alert>
			</div>
		</>
	);
};

export default NoOrganizationLoanAccess;
